import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import {
	type LWApiPublicSupportRequestDetailsParamsRawI,
	type LWApiPublicSupportRequestDetailsResultRawI,
} from '@liquidweb-dev/club-sauce/public/support/request/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const SUPPORT_REQUEST_DETAILS_QUERY_KEY = '/support/request/details';

const useSupportRequestDetails = (
	params: LWApiPublicSupportRequestDetailsParamsRawI,
	options?: UseQueryOptions<
		LWApiPublicSupportRequestDetailsResultRawI,
		ApiErrorI
	>,
) =>
	useQuery({
		queryKey: [SUPPORT_REQUEST_DETAILS_QUERY_KEY, params],
		queryFn: () => api.support.request.apiRaw.details(params),
		...options,
	});

export default useSupportRequestDetails;
